<div class="modal-header">
  <h4 class="modal-title fw-normal">{{ title }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>
<div class="modal-body">
  <div [class]="alertClasses" role="alert">
    <p class="mb-0">{{ message }}</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">{{ cancelButtonText }}</button>
  <button type="button" [class]="'btn btn-primary'" (click)="onConfirm()">{{ confirmButtonText }}</button>
</div>
